import { apiFetch } from './client';

export async function startLiveChat(payload, files = []) {
  const body = new FormData();
  body.append('payload', JSON.stringify(payload));
  files.forEach((file) => body.append('files', file));
  try {
    const response = await apiFetch('/chat/live', { method: 'POST', body, timeoutMs: 180000 });
    return await response.json();
  } catch (error) {
    if (error?.status && error.status < 500) throw error;
    // The acknowledgement can be lost after admission. Look up its receipt, never POST twice.
    try {
      const response = await apiFetch(`/chat/live/${encodeURIComponent(payload.request_id)}`, { timeoutMs: 15000 });
      return await response.json();
    } catch { throw error; }
  }
}

export async function listLiveChats() {
  const response = await apiFetch('/chat/live', { timeoutMs: 15000 });
  return response.json();
}

export async function getLiveChat(id) {
  const response = await apiFetch(`/chat/live/${encodeURIComponent(id)}`, { timeoutMs: 15000 });
  return response.json();
}

export async function cancelLiveChat(id) {
  const response = await apiFetch(`/chat/live/${encodeURIComponent(id)}/cancel`, { method: 'POST', timeoutMs: 15000 });
  return response.json();
}

// Read-only polling resumes the same server job; never resubmits model work.
export async function watchLiveChat(id, { onRun, onConnection, isCancelled, sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms)) } = {}) {
  let after = -1;
  let failures = 0;
  while (!isCancelled?.()) {
    try {
      const response = await apiFetch(`/chat/live/${encodeURIComponent(id)}${after >= 0 ? `?after=${after}` : ''}`, { timeoutMs: 15000 });
      const run = await response.json();
      if (isCancelled?.()) return null;
      failures = 0;
      onConnection?.(true);
      onRun?.(run);
      after = Number(run.revision ?? after);
      if (['completed', 'failed', 'cancelled'].includes(run.status)) return run;
      await sleep(600);
    } catch (error) {
      if (isCancelled?.()) return null;
      onConnection?.(false);
      failures += 1;
      if ([401, 403, 404].includes(error?.status) || failures >= 20) throw error;
      await sleep(Math.min(5000, failures * 750));
    }
  }
  return null;
}
